import { Preset, IncludedCurrentFace } from './types';
import { CURRENT_FACE_RANGE_PRESET } from '@/creditflowresearch/ui/components/bonds/common/BondsSidebar/constants';

export const presetMap = new Map(
  CURRENT_FACE_RANGE_PRESET.map((preset) => [preset.currentFaceRangeId, preset]),
);

export const getPresetById = (id: number): Preset | undefined => presetMap.get(id.toString());

export const findMatchingPreset = (
  includedCurrentFace: IncludedCurrentFace,
): Preset | undefined => [...presetMap.values()].find(
    (preset) => preset.currentFaceRangeFromValue === includedCurrentFace.includedCurrentFaceFrom &&
      preset.currentFaceRangeToValue === includedCurrentFace.includedCurrentFaceTo,
  );

export const isFromPreset = (
  includedCurrentFaces: IncludedCurrentFace[] = [],
): boolean => includedCurrentFaces.length > 1;

export const getSingleFaceRangeValue = (
  faces: IncludedCurrentFace[] | undefined,
  key: keyof IncludedCurrentFace,
): number | null => (faces && !isFromPreset(faces) ? faces[0]?.[key] ?? null : null);
